import { jsx as _jsx } from "react/jsx-runtime";

const JsonLd = ({
  item,
  replacer,
  space = 2
}) => /*#__PURE__*/_jsx("script", {
  type: "application/ld+json",
  dangerouslySetInnerHTML: {
    __html: JSON.stringify(item, replacer, space)
  }
});

export default JsonLd;